import { DocumentProviderType } from 'models/documentProvider';
import ResourceListDTO from 'models/dto/resourceListDTO';
import ResourceList from 'models/resourceList';

export function mapFromResourceList(list: ResourceListDTO): ResourceList {
  const output = new ResourceList();
  output.tenantId = list.tenantId;
  output.listId = list.listId;
  output.authSchemaId = list.authSchemaId;
  output.listType = list.listType;
  output.systemListId = list.systemListId;
  // an absent value is a category from before providers existed, which is SharePoint
  output.providerType = (list.providerType ?? DocumentProviderType.SharePoint) as DocumentProviderType;
  output.connectionId = list.connectionId;
  output.name = list.name;
  output.webURL = list.webURL;
  output.altTenantId = list.altTenantId;
  output.altTenantName = list.altTenantName;
  output.spListId = list.spListId;
  output.spSiteId = list.spSiteId;
  output.spDriveId = list.spDriveId;
  output.spDriveItemId = list.spDriveItemId;
  output.columnProps = list.columnProps;
  output.enableMetaData = list.enableMetaData;
  output.isVirtual = list.isVirtual;
  output.skipPreview = list.skipPreview;

  return output;
}

export function mapToResourceList(list: ResourceList): ResourceListDTO {
  const output = new ResourceListDTO();
  output.listId = list.listId;
  output.authSchemaId = list.authSchemaId;
  output.listType = list.listType;
  output.systemListId = list.systemListId;
  output.providerType = list.providerType;
  output.connectionId = list.connectionId;
  output.name = list.name;
  output.webURL = list.webURL;
  output.altTenantId = list.altTenantId;
  output.altTenantName = list.altTenantName;
  output.spListId = list.spListId;
  output.spSiteId = list.spSiteId;
  output.spDriveId = list.spDriveId;
  output.spDriveItemId = list.spDriveItemId;
  output.columnProps = list.columnProps;
  output.enableMetaData = list.enableMetaData;
  output.isVirtual = list.isVirtual;
  output.skipPreview = list.skipPreview;

  return output;
}

export function mapFromResourceLists(lists: ResourceListDTO[]): ResourceList[] {
  return lists.map((_list) => {
    return mapFromResourceList(_list);
  });
}
